import { Box, Button } from "@mui/material";
import React from "react";
import GoToIcon from "../IconComp/goToIcon";
import { ColorPallet } from "../../utils/colorPallet";

interface IProps {
  data: any[];
  title: string;
  buttonTitle: string;
  onClick?: () => void;
}

const ListOfExpiredMedCard = ({
  data,
  title,
  buttonTitle,
  onClick,
}: IProps) => {
  const allArraysEmpty = data?.every(
    (item) =>
      item.expiredBatchNumbers?.length === 0 &&
      item.expiredname?.length === 0 &&
      item.expiryDate?.length === 0
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        bgcolor: ColorPallet?.bgcolor,
        border: `1px solid ${ColorPallet?.borderColor}`,
        width: "100%",
        borderRadius: "4px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          borderBottom: `1px solid ${ColorPallet?.borderColor}`,
          paddingTop: 2,
          paddingBottom: 1,
          fontSize: {
            xs: "14px", // Default font size for xs screens
          },
          "@media (min-width:320px) and (max-width:370px)": {
            fontSize: "12px", // Adjusted font size for 320px to 370px
          },
        }}
      >
        <Box
          sx={{
            fontSize: "16px",
            fontWeight: "bold",
            paddingLeft: { xs: "8px", sm: "20px" },
            marginTop: "5px",
          }}
        >
          {title}
        </Box>
        <Box
          sx={{
            paddingRight: "20px",
            cursor: "pointer",
          }}
        >
          <Button
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "8px",
              fontWeight: "normal",
              textTransform: "capitalize",
            }}
            onClick={onClick}
          >
            {buttonTitle}
            <GoToIcon />
          </Button>
        </Box>
      </Box>
      {allArraysEmpty ? (
        <Box sx={{ p: 5, textAlign: "center" }}>No Expired Batches</Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            p: 2,
          }}
        >
          {data?.map((item: any, index: number) => (
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  display: "flex",
                  flexDirection: "row",
                  maxHeight: "150px",
                  pl: "5px",
                  pr: {
                    xs: 0,
                    md: 2,
                  },
                  justifyContent: "space-between",
                  overflowY: "auto",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    gap: {
                      xs: 1,
                      md: 12,
                    },
                    fontSize: {
                      xs: "14px", // Default font size for xs screens
                    },
                    "@media (min-width:320px) and (max-width:370px)": {
                      fontSize: "12px", // Adjusted font size for 320px to 370px
                    },
                  }}
                >
                  {item?.expiredBatchNumbers && (
                    <div>
                      <span>
                        {item?.expiredBatchNumbers?.map(
                          (batchNumber: any, index: any) => (
                            <div
                              key={index}
                              style={{
                                marginBottom: "20px",
                              }}
                            >
                              {batchNumber}
                            </div>
                          )
                        )}
                      </span>
                    </div>
                  )}

                  {item?.expiredname && (
                    <div>
                      <span>
                        {item?.expiredname?.map((name: any, index: any) => (
                          <div
                            key={index}
                            style={{
                              marginBottom: "20px",
                            }}
                          >
                            {name}
                          </div>
                        ))}
                      </span>
                    </div>
                  )}
                </Box>
                <Box
                  sx={{
                    fontSize: {
                      xs: "14px", // Default font size for xs screens
                    },
                    "@media (min-width:320px) and (max-width:370px)": {
                      fontSize: "12px", // Adjusted font size for 320px to 370px
                    },
                  }}
                >
                  {item?.expiryDate && (
                    <div>
                      <span>
                        {item?.expiryDate?.map(
                          (dateString: any, index: any) => (
                            <div
                              key={index}
                              style={{
                                marginBottom: "20px",
                              }}
                            >
                              {new Date(dateString)?.toLocaleDateString()}
                            </div>
                          )
                        )}
                      </span>
                    </div>
                  )}
                </Box>
              </Box>
              <Box sx={{ mt: 1 }}>{item?.title}</Box>{" "}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default ListOfExpiredMedCard;
